import react from "react";

import cp1 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL001 copy Large.jpeg";
import cp2 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL002 copy Large.jpeg";
import cp3 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL003 copy Large.jpeg";
import cp4 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL004 copy Large.jpeg";
import cp5 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL005 copy Large.jpeg";
import cp6 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL006 copy Large.jpeg";
import cp7 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL007 copy Large.jpeg";
import cp8 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL008 copy Large.jpeg";
import cp9 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL009 copy Large.jpeg";
import cp10 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL010 copy Large.jpeg";
import cp11 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL011 copy Large.jpeg";
import cp12 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL012 copy Large.jpeg";
import cp13 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL013 copy Large.jpeg";
import cp14 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL014 copy Large.jpeg";
import cp15 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL015 copy Large.jpeg";
import cp16 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL016 copy Large.jpeg";
import cp17 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL017 copy Large.jpeg";
import cp18 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL018copy Large.jpeg";
import cp19 from "../images/commercials/CP Company Campaign/CPCOMPANY_FINAL019 Large.jpeg";


const CPCompanyCampaign = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={cp1} alt="CP Company Campaign Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={cp2} alt="CP Company Campaign Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={cp3} alt="CP Company Campaign Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={cp4} alt="CP Company Campaign Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={cp5} alt="CP Company Campaign Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={cp6} alt="CP Company Campaign Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={cp7} alt="CP Company Campaign Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={cp8} alt="CP Company Campaign Commercial Photography - Image 8"/>
                </div>
                 <div className="single portrait">
                    <img src={cp9} alt="CP Company Campaign Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={cp10} alt="CP Company Campaign Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={cp11} alt="CP Company Campaign Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={cp12} alt="CP Company Campaign Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={cp13} alt="CP Company Campaign Commercial Photography - Image 13"/>
                </div>
                 <div className="single portrait">
                    <img src={cp14} alt="CP Company Campaign Commercial Photography - Image 14"/>
                </div>
                <div className="single portrait">
                    <img src={cp15} alt="CP Company Campaign Commercial Photography - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={cp16} alt="CP Company Campaign Commercial Photography - Image 16"/>
                </div>
                <div className="single portrait">
                    <img src={cp17} alt="CP Company Campaign Commercial Photography - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={cp18} alt="CP Company Campaign Commercial Photography - Image 18"/>
                </div>
                 <div className="single portrait">
                    <img src={cp19} alt="CP Company Campaign Commercial Photography - Image 19"/>
                </div>
            </div>
        </div>
    );
}

export default CPCompanyCampaign;